const timeSeries = {
  queryState: {
    projectMetaLoadFailed: "地図情報を読み込めませんでした",
    mappingImageListLoadFailed: "画像を読み込めませんでした",
    mappingImageListNotLoaded: "まだ画像を読み込んでいません",
    issueListLoadFailed: "イシュー一覧を読み込めませんでした",
    projectNotSelected: "読み込む対象のプロジェクトが指定されていません",
  },
  clip: {
    title: "断面ツール",
    count: "全{{count}}個",
    addClipping: "断面を追加",
    clippingList: "断面リスト",
    box: "ボックス",
    plane: "平面",
    boxName: "ボックス {{index}}",
    planeName: "平面 {{index}}",
    addBySurfaceClick: "表面クリックで追加",
    placingHint: "3D画面でモデルの表面をクリックしてください",
    placingCancel: "右クリックまたはESCでキャンセル",
    limitNotice: "同時適用は最大{{max}}個までです",
    emptyList: "追加された断面がありません。",
    emptyListDesc: "上から断面を追加してください。",
    toggleItem: "断面の表示",
    toggleItemNamed: "{{name}} の表示",
    itemGroupNamed: "{{name}} の設定",
    deleteNamed: "{{name}} を削除",
    deleteTitle: "断面の削除",
    deleteConfirm: "「{{name}}」断面を削除しますか？",
    deleteIrreversible: "削除した断面は復元できません。",
    deleteCancel: "キャンセル",
    deleteConfirmAction: "削除",
    sizeLabel: "一辺",
    namePlaceholder: "断面名",
    nameInputLabel: "名前",
    renameNamed: "{{name}} の名前を変更",
    renameTitle: "断面名の変更",
    renameConfirm: "変更",
    renameCancel: "キャンセル",
    delete: "削除",
    disabledTitle: "オフの断面",
    disabledDesc: "スイッチをオンにして使用",
    editMode: "編集",
    editTooltipMain: "頂点・面を直接つかんで形状を変更",
    editTooltipSub: "オフにするとモデルをつかんでカメラ移動",
    wireframe: "エッジ",
    capFill: "断面の塗り",
    invert: "反転",
    save: "保存",
    unsavedChanges: "未保存の変更",
    loading: "断面リストを読み込み中…",
    loadFailed: "断面リストを読み込めませんでした",
    retry: "再試行",
    saveFailed: "保存に失敗しました。もう一度お試しください。",
    horizontal: "水平",
    vertical: "垂直",
    gap: "間隔",
    area: "面積",
    rotation: "回転",
    tilt: "傾き",
    reset: "リセット",
    undo: "元に戻す",
    redo: "やり直し",
  },
  page: {
    title: "時系列点検",
  },
  sidebar: {
    layers: "レイヤー",
    projectInfo: "プロジェクト情報",
    issues: "イシュー",
    report: "レポート",
  },
  modal: {
    issueInfo: "イシュー情報",
    crossSection: "線形断面図",
  },
  map: {
    satelliteMap: "衛星地図",
    viewerCount: "ビューア数",
    imageList: "画像リスト",
    favoriteOnly: "お気に入りのみ表示",
    standard: "基準",
    noImages: "画像がありません",
    nearbyImagesOnly: "近傍100mまでの写真が表示されます",
  },
  drawingTools: {
    draw: "作成",
    edit: "編集",
    etc: "その他",
  },
  toolbar3d: {
    create: "作成",
    measurement: "測定",
    howToUse: "使い方",
    backgroundColor: "背景色変更",
    resetView: "初期画面",
  },
  mapTool: {
    tool: {
      splitView: "画面分割",
      splitViewCount: "{{count}}分割表示",
      fullscreen: "全画面",
      exitFullscreen: "全画面を終了",
      zoomIn: "拡大",
      zoomOut: "縮小",
      marker: "点",
      multiMarker: "複数点",
      line: "線",
      polygon: "面",
      rectangle: "四角形",
      text: "テキスト",
      modify: "頂点編集",
      move: "移動",
      delete: "削除",
      distance: "距離計測",
      orthogonal: "垂直計測",
      area: "面積計測",
      profile: "縦断計測",
      remover: "計測消しゴム",
      droneImage: "ドローン画像",
      areaCapture: "範囲キャプチャ",
      annotationTitle: "課題名を表示",
    },
    autoIssueName: "課題 {{n}}",
    issueLayerOn: {
      notice: "課題レイヤーをオンにしました",
    },
    deleteConfirm: {
      cancel: "キャンセル",
      subtitle: "課題「{{name}}」を削除しますか？",
      irreversible: "削除した課題は元に戻せません",
    },
  },
  messages: {
    annotationCreated: "アノテーション作成完了",
    annotationUpdated: "アノテーション修正完了",
    annotationDeleted: "アノテーション削除完了",
    annotationCreateFailed: "アノテーション作成失敗",
    annotationUpdateFailed: "アノテーション修正失敗",
    annotationDeleteFailed: "アノテーション削除失敗",
    issueDeleted: "イシューが削除されました。",
    issueDeleteFailed: "イシューの削除に失敗しました。",
    issueDeleteFailedForUsage:
      "選択したイシューは他のアノテーションで使用中です。",
    selectDateToDelete: "削除する日付を選択してください。",
  },
  deleteModal: {
    title: "イシュー削除",
    confirmMessage: "本当にイシューを削除しますか？",
    delete: "削除",
  },
  layerDeleteModal: {
    title: "レイヤー削除",
    delete: "削除",
    cancel: "キャンセル",
    enterEditMode: "レイヤー削除",
    deleteSuccess: "レイヤーが削除されました。",
    deleteFailed: "レイヤーの削除に失敗しました。",
  },
  annotationVisibilityConfirm: {
    title: "アノテーション表示がオフになっています",
    subTitle:
      "選択したイシューを見るにはアノテーション表示をオンにする必要があります。オンにしますか？",
    confirm: "オンにする",
    cancel: "キャンセル",
  },
  issue: {
    create: "イシュー作成",
    filter: "フィルター",
    empty: "イシューがありません",
    total: "全体",
    reset: "初期化",
    apply: "適用",
    cancel: "キャンセル",
    save: "保存",
    delete: "削除",
    edit: "修正",
    export: "イシューエクスポート",
    exportTitle: "分析時系列選択",
    exportDescription:
      "希望する時系列を選択して確認ボタンを押すと、日付別に測定値を比較することで時間の経過に伴うイシューの進行度及び悪化度を確認できます。",
    exportHint:
      "入力されていない項目があります。すべての内容を記入してください。",
    noData: "使用可能な時系列データがありません。",
    linkFailed: "イシュー連携失敗",
    confirm: "確認",
    commentCount: "コメント{{count}}件",
    unexportTitle: "イシュー書き出しの解除",
    unexportConfirm: "{{dates}} のイシューが削除されます。",
    unexportIrreversible:
      "削除したイシューは復元できません。その日付の等級・座標の編集内容も一緒に失われます。",
    unexportAction: "解除",
    applying: "イシュー書き出しを適用中",
    applySuccess: "イシュー連携成功",
    partialFailure: "一部の項目を処理できませんでした。({{count}}件)",
  },
  form: {
    type: "注釈タイプ",
    name: "名前",
    fontSize: "フォントサイズ",
    size: "サイズ(px)",
    color: "色",
    opacity: "透明度",
    position: "位置",
    lonlat: "経緯度",
    xCoord: "x座標",
    yCoord: "y座標",
    issue: "イシュー種類",
    category: "分類基準",
    categoryPlaceholder: "分類基準選択",
    grade: "強度",
    gradePlaceholder: "選択",
    memo: "メモ",
    photo: "写真",
  },
  layer: {
    noModels: "構築されたモデルがありません",
    orthomosaic: "オルソモザイク画像",
    dsm: "数値表面モデル",
    stratum: "層レイヤー",
    design: "設計レイヤー",
    line: "線形レイヤー",
    longitudinal: "縦断面",
    crossSection: "横断面",
    crossSectionList: "横断面リスト",
    specificCrossSection: "特定横断面",
  },
  export: {
    shootingDate: "撮影日",
    ground: "地盤高",
    plan: "計画高",
    stratum: "地層",
    selectDate: "日付選択",
    selectFile: "ファイル選択",
    create: "作成",
    creating: "作成中...",
    alertMessage:
      "処理完了したファイルのみ使用でき、ファイル作成はリクエスト後最大10分以内に完了します。\n土工集計表：計画高を選択しない場合、選択した設計地盤高と現況ドローン地盤高の差で残余数量を計算します。",
    noSection: "選択されたセクションがありません。",
    createStarted: "ファイル作成が開始されました。",
    notFound: "横断面データが見つかりません。",
    createFailed: "ファイル作成に失敗しました。",
    downloadTooltip:
      "ダウンロードボタンを押すと横断面情報を\nCSVなどさまざまな形式のファイルでエクスポートできます。",
  },
  projectInfo: {
    title: "情報",
    edit: "編集",
    project: "プロジェクト",
    mapping: "マッピング",
  },
  issueList: {
    title: "イシュー",
    total: "総イシュー",
    create: "イシュー作成",
    filter: "フィルター",
    noIssues: "登録されたイシューがありません",
    noFilteredIssues: "フィルタリングされたイシューがありません",
    flyTo: "イシューへ移動",
    flyToAria: "{{name}} イシューへ移動",
    notInCurrentTimeSeriesTitle: "現在の時系列にないイシュー",
    notInCurrentTimeSeriesBody:
      "このイシューは現在の時系列に存在しません。イシュー情報の「イシューエクスポート」で現在の時系列に作成できます。",
    openIssueInfo: "イシュー情報を開く",
    close: "閉じる",
  },
  layerFlyTo: {
    label: "図面へ移動",
    aria: "{{name}} 図面へ移動",
    blockedFar:
      "現場から約 {{distance}} km 離れているため移動しません。ファイルの座標系を確認してください。",
    blockedUnresolvable: "レイヤーの範囲を解釈できないため移動しません。",
  },
  issueDetail: {
    grade: "イシュー強度",
    type: "イシュー種類",
    tool: "アノテーションツール",
    created: "イシュー作成日",
    updated: "イシュー修正日",
    creator: "最初の作成者",
    gradeTrend: "イシュー強度推移",
    noDate: "日付なし",
    notInTimeSeries: "このイシューは選択された基準時系列にありません。",
    linkToTimeSeries:
      "基準時系列を変更するか、基準時系列にイシューを連携してください。",
  },
  measurement: {
    coordinates: "座標",
    coordinatesFile: "座標情報",
    measurementFile: "測定情報",
    volumeFile: "体積情報",
    line: "線情報",
  },
  transferList: {
    timeSeriesList: "時系列リスト",
    selectedTimeSeries: "選択時系列",
    selectAll: "全て選択",
    standard: "基準",
    export: "エクスポート",
  },
  issueTypeModal: {
    title: "イシュー種類管理",
    close: "モーダルを閉じる",
    searchPlaceholder: "検索語を入力してください",
    addType: "種類追加",
    issueName: "イシュー名",
    add: "追加",
    enterName: "イシュー種類名を入力してください。",
    typeAdded: "新しいイシュー種類が追加されました。",
    addFailed: "イシュー種類の追加に失敗しました。",
  },
  profile: {
    title: "プロファイル",
    close: "閉じる",
    resetView: "画面初期化",
    overflowMenu: "その他",
    copyCoordinate: "座標をコピー",
    copied: "コピーしました",
    copyFailed: "コピーできませんでした",
    copyHint: "グラフをクリックすると座標をコピーできます",
    fullscreen: "全画面",
    exitFullscreen: "全画面終了",
    themeToggleToLight: "ライトテーマ",
    themeToggleToDark: "ダークテーマ",
    labelMode: {
      prefix: "ラベル",
      hover: "ホバー",
      on: "固定",
      tooltipHover: "ラベルホバー表示",
      tooltipOn: "ラベル固定表示",
    },
    opacity: {
      label: "モーダル透明度",
      tooltip: "モーダル透明度調整",
    },
    colorMode: {
      prefix: "色",
      model: "モデル",
      real: "実写",
      tooltipModel: "各モデルを固有色で表示",
      tooltipReal: "3Dモデルの原本色で表示",
    },
    colorModes: {
      realistic: "実写",
      model: "モデル",
      modelByModel: "モデル別",
      comingSoon: "準備中",
    },
    capture: {
      tooltip: "画像キャプチャ",
      formats: {
        png: "PNG",
        jpg: "JPG",
        jpeg: "JPEG",
        webp: "WEBP",
      },
    },
    measureTools: {
      point: "点測定",
      polyline: "直線測定（クリックで点追加、右クリックで確定）",
      axes: "軸測定（多数の垂直・水平交差点測定）",
      rectangle: "グリッド測定",
      circle: "円測定",
      erase: "測定削除",
      eraseSelect: "選択削除",
      eraseSelectHint: "測定点/図形/ラベルをクリックして個別削除",
      eraseAll: "全て削除",
      eraseAllHint: "プロファイルグラフ上のすべての測定を削除",
    },
    colorModePopover: {
      title: "色モード",
      realisticHint: "キャプチャされた原本の色をそのまま表示します。",
      modelHint: "各モデルを固有色で表示します。モデルフィルター使用可能。",
    },
    modelFilter: {
      title: "モデルフィルター",
      modeOnly: "モデル別モードでのみ使用できます。",
      empty: "表示するモデルがありません。",
    },
    modelLegend: {
      ariaList: "モデル色凡例",
      toggleHide: "断面を非表示",
      toggleShow: "断面を表示",
    },
    axis: {
      distance: "距離 (m)",
      orthoHeight: "高さ (m)",
      deltaHeight: "Δ高さ",
      deltaDistance: "Δ距離",
    },
    coordinateLabels: {
      longitude: "経度",
      latitude: "緯度",
      ellipsoidHeight: "楕円体高",
    },
    coordSystemWarning: {
      unsupportedEpsg:
        "サポートされていない座標系(EPSG:{epsg})のプロジェクトです。KOREA2000座標表示は使用できません。",
    },
    loading: {
      capturing: "断面作成中...",
      captureFailed: "断面画像読み込み失敗",
    },
    empty: {
      noIntersection: "断面と交差するBIM/Meshモデルが見つかりませんでした。",
    },
    metrics: {
      sharpness: "鮮明度",
      accuracy: "精度",
      confidence: "信頼度",
      tooltips: {
        sharpness:
          "断面画像のピクセルサイズ。値が大きいほどズームイン時によりきれいに見えます。測定精度とは無関係で、ディスプレイのピクセル密度(DPR)とパネルサイズによって異なります。",
        accuracy:
          "プロジェクト3DモデルのGSDベース理論的測定限界。モデル自体のピクセル分解能に由来します。",
        confidence:
          "実際の測定時に信頼できる保守的な誤差範囲。GSDの約2倍と推定されます。",
      },
    },
    fullExport: {
      currentStation: "現在のステーションを抽出",
      currentStationDescription: "現在のステーション1件をすぐにダウンロードします。",
      allStationsTitle: "全ステーション抽出",
      allStationsDescription: "抽出結果はこのパネルのエクスポート履歴に保存され、そこからCSV・DXFをダウンロードできます。",
      confirmTitle: "全ステーション抽出",
      confirmMessage: "結果はこのパネルのエクスポート履歴からダウンロードできます。",
      stationCount: "ステーション",
      start: "抽出開始",
      started: "全ステーション抽出を開始しました。",
      tooLargeSectionLength: "作業量が上限を超えています — {{axis}} {{actual}} / 最大 {{maximum}}。横断間隔を広げるか、線分の範囲・幅設定を狭めるか、表示中のレイヤーを減らしてください。",
      tooLargeSamples: "作業量が上限を超えています — {{axis}} {{actual}} / 最大 {{maximum}}。点間隔・横断間隔を広げるか、線分の範囲・幅設定を狭めるか、表示中のレイヤーを減らしてください。",
      tooLargeUnknownAxis: "作業量が上限を超えています — {{axis}} {{actual}} / 最大 {{maximum}}。",
      axisSectionLength: "断面長の合計(m) × レイヤー数",
      axisSamples: "点の総数",
      inProgress: "このアノテーションの全ステーション抽出はすでに進行中です。エクスポート履歴で確認してください。",
      capacityReached: "現在、全ステーション抽出の要求が多くなっています。しばらくしてから再度お試しください。",
      startFailed: "全ステーション抽出を開始できませんでした。",
      fileSuffix: "全体",
    },
    exportHistory: {
      title: "エクスポート履歴",
      buttonRunning: "エクスポート履歴 · {{percent}}%",
      buttonCompleted: "エクスポート履歴 · 完了",
      buttonFailed: "エクスポート履歴 · 失敗",
      empty: "全ステーション抽出の結果はここからダウンロードできます。",
      loadFailed: "エクスポート履歴を読み込めませんでした。",
      summary: "ステーション {{stations}} · 点間隔 {{step}} m · レイヤー {{series}}",
      sectionSettings: "区間 {{first}}–{{last}} · 開始測点 {{start}} m · 横断間隔 {{interval}} m · 左/右 {{left}}/{{right}} m",
      completed: "完了",
      failed: "失敗",
      detailsLabel: "{{time}} の履歴({{status}})の詳細",
      progressLabel: "全ステーション抽出の進捗",
      downloadCsv: "{{time}} の履歴の CSV をダウンロード",
      downloadDxf: "{{time}} の履歴の DXF をダウンロード",
      delete: "削除",
      deleteLabel: "{{time}} の履歴を削除",
      notFound: "履歴が見つかりません。",
      downloadFailed: "ファイルを作成できませんでした。",
      deleteFailed: "履歴を削除できませんでした。",
    },
  },
  report: {
    title: "レポート",
    create: "レポート作成",
    export: "レポートエクスポート",
    formTitle: "タイトル",
    titlePlaceholder: "レポートのタイトルを入力してください",
    author: "作成者",
    authorPlaceholder: "作成者を入力してください",
    organization: "所属",
    job: "職務",
    email: "メールアドレス",
    phone: "電話番号",
  },
  vector: {
    title: "ベクター",
    totalCount: "全 {{count}}件",
    showOnMap: "地図に表示",
    create: {
      sectionTitle: "ベクター作成",
      open: "座標入力で作成",
      name: "名前",
      namePlaceholder: "ベクター名",
      modeLngLat: "緯度/経度",
      modeProjectCrs: "X/Y 座標",
      lng: "経度",
      lat: "緯度",
      x: "X",
      y: "Y",
      elHeight: "高さ(m)",
      color: "色",
      radius: "半径(m)",
      shape: "形状",
      shape_line: "線",
      shape_cylinder: "円柱",
      shape_square: "四角柱",
      side: "一辺(m)",
      shapeLineNoSize: "線はサイズなし",
      radiusValueHint: "値を入力",
      commentPlaceholder: "メモを入力してください（任意）",
      addPoint: "点を追加",
      submit: "作成",
      epsgUnavailable: "プロジェクト座標系を確認できません。",
      createFailed: "ベクターの作成に失敗しました。",
    },
    list: {
      sectionTitle: "ベクター一覧",
      empty: "作成されたベクターがありません。",
      emptyDesc: "上で座標を入力して作成してください。",
      loading: "ベクターを読み込み中…",
      loadFailed: "ベクターの読み込みに失敗しました。",
      retry: "再試行",
      radius: "半径(m)",
      line: "線",
      radiusValue: "{{symbol}} {{value}}m",
      pointCount: "点 {{count}}個",
      delete: "削除",
      deletePoints: "点を削除",
      deleteConfirmTitle: "ベクター削除",
      deleteConfirmMessage: "「{{name}}」を削除しますか？",
      deleteIrreversible: "削除後は元に戻せません。",
      deleteFailed: "ベクターの削除に失敗しました。",
      updateFailed: "ベクターの更新に失敗しました。",
      infoSection: "情報",
      coordinates: "座標リスト",
      perpendicular: "垂直断面",
      save: "保存",
      reset: "リセット",
    },
    perpendicular: {
      title: "垂直断面",
      position: "切断位置（始点から, m）",
      totalLength: "全長 {{length}}m",
      meterUnit: "m",
      positionRange: "切断位置は0以上全長以下である必要があります。",
      length: "切断線の長さ(m)",
      confirm: "確認",
      lengthRange: "長さは0より大きく1000以下である必要があります。",
      invalid:
        "切断線を計算できません。\n垂直または一点のベクトルは断面を作成できません。",
    },
    selection: {
      selectDelete: "削除",
      selectAll: "全て選択",
      deselectAll: "全て解除",
      confirm: "確認",
      confirmMessage: "{{count}}個のベクターを削除しますか？",
      minPointsHint: "点は最低{{count}}個残す必要があります",
    },
    errors: {
      nameLength: "名前は{{nameMin}}~{{nameMax}}文字である必要があります。",
      commentLength: "メモは{{commentMax}}文字以下である必要があります。",
      minPoints: "点は最低{{minPoints}}個必要です。",
      maxPoints: "点は最大{{maxPoints}}個まで入力できます。",
      notNumber: "数値を入力してください。",
      lngRange: "経度は{{lngMin}}~{{lngMax}}の範囲である必要があります。",
      latRange: "緯度は{{latMin}}~{{latMax}}の範囲である必要があります。",
      radiusRange:
        "半径は{{sizeExclusiveMin}}より大きく{{maxRadius}}以下である必要があります。",
      sideRange:
        "一辺は{{sizeExclusiveMin}}より大きく{{maxSide}}以下である必要があります。",
    },
  },
  geoLog: {
    title: "写真·動画",
    totalCount: "全{{count}}件",
    showOnMap: "地図に表示",
    noFilesHint: "地図が読み込まれるとファイルが表示されます。",
    emptyFiles: "登録された写真·動画がありません。",
    noPosition: "位置なし",
    groupCount: "{{count}}件",
    locationGroup: {
      noPositionDesc: "まだ地図に表示されていない写真です。",
    },
    uncategorized: "未分類",
    noCaptureDate: "撮影日なし",
    uploaderMe: "私",
    groupEdit: {
      title: "グループ一括編集",
      label: "グループ一括編集",
      titleField: "{{field}}を一括編集",
      desc: "このグループの写真{{count}}枚に同じ{{field}}を一括で適用します。",
    },
    view: {
      captureDate: "撮影日別",
      category: "主題別",
      uploader: "登録者別",
      locationName: "位置別",
    },
    sort: {
      latest: "新しい順",
      oldest: "古い順",
    },
    position: {
      modalTitle: "位置設定",
      placeCard: "位置を指定",
      placeHint: "地図に指定",
      clearCard: "位置解除",
      clearHint: "位置を削除",
      attachCard: "既存位置に追加",
      attachHint: "既存位置にまとめる",
      unnamedLocation: "名称なしの位置",
      existingCount: "既存{{count}}枚",
      addAction: "ここに追加",
      selectTargetHint:
        "既に位置がある地点に写真をまとめて追加できます。\nまず追加する既存位置を選択してください。",
      placeStepHint:
        "地図の空いた場所をクリックすると新しい位置、既存マーカーをクリックするとその位置に追加されます。\n指定する写真を選択してください。",
      clearStepHint:
        "写真に指定された位置を解除できます。\n位置を解除する写真を選択してください。",
      attachStepHint:
        "選択した写真をこの位置にまとめて表示できます。\nこの位置に追加する写真を選択してください。",
      noLocation: "指定された位置がありません",
      back: "戻る",
      selectAll: "全選択",
      deselectAll: "選択解除",
      placeEmpty: "位置のない写真がありません",
      clearEmpty: "位置のある写真がありません",
    },
    toolbar: {
      upload: "アップロード",
      place: "位置設定",
      delete: "削除",
      download: "ダウンロード",
    },
    upload: {
      modalTitle: "アップロード",
      fileCard: "ファイルをアップロード",
      fileCardHint: "端末からファイルを選択",
      folderCard: "フォルダをアップロード",
      folderCardHint: "フォルダ全体を選択",
      mapCard: "地図上にアップロード",
      mapCardHint: "地図にドラッグ＆ドロップ",
      dropZoneHint: "またはファイル·フォルダをここにドロップ",
      dropActive: "ここにドロップでアップロード",
      sizeLimit: "一度に最大{{limit}}までアップロードできます",
      uploading: "アップロード中...",
      uploadingShort: "アップロード中",
      queued: "待機中",
      cancel: "キャンセル",
    },
    selection: {
      count: "{{count}}件選択",
      selectGroup: "グループ全体を選択",
      confirm: "地図に指定",
      deleteTitle: "ファイル削除",
      deleteIrreversible: "削除したファイルは復元できません。",
      delete: "削除",
      cancel: "キャンセル",
      clear: "位置解除",
      deleteConfirm: "選択した{{count}}件のファイルを削除しますか？",
      download: "ダウンロード",
      selectDelete: "選択削除",
      selectDownload: "選択ダウンロード",
      downloadTitle: "ファイルのダウンロード",
      downloadConfirm: "選択した{{count}}件のファイルをダウンロードしますか？",
    },
    edit: {
      date: "日付",
      category: "主題",
      categoryPlaceholder: "主題を選択または入力",
      locationName: "位置名",
      locationNamePlaceholder: "例: 1番橋脚, 東側入口",
      save: "保存",
      reset: "元に戻す",
      cancel: "キャンセル",
    },
    cell: {
      moveToPosition: "位置へ移動",
      setPosition: "位置を指定",
      detail: "詳細表示",
      moveToPositionAria: "{{name}} の位置へ移動",
      setPositionAria: "{{name}} の位置を指定",
      detailAria: "{{name}} の詳細を表示",
    },
    detail: {
      uploader: "登録者",
      fileSize: "容量",
      locationJoinPlaceholder: "既存の位置名を選択",
      locationJoinHint:
        "既存の位置に保存されます。新しい位置は右上の「位置指定」ボタンで指定してください。",
      locationMoveHint: "選択した位置にこの写真だけ移動します。",
      locationAssignHint: "現在の位置に新しい位置名として保存されます。",
      locationRenameGuide:
        "位置名は位置の名前です。名前の変更は地図のプレビューカードまたはサイドバーの位置別表示のグループ編集から行え、その位置のすべての写真に適用されます。",
      captureDate: "撮影日",
      category: "主題",
      locationName: "位置名",
      viewPosition: "位置を確認",
      viewPositionShort: "確認",
      movePosition: "移動",
      movePositionAria: "位置を移動",
      expand: "拡大表示",
      collapse: "縮小表示",
    },
    pano: {
      view360: "360°",
      viewFlat: "2D",
      resetView: "初期画面",
      play: "再生",
      pause: "一時停止",
      mute: "ミュート",
      unmute: "ミュート解除",
      seek: "再生位置",
    },
    roadview: {
      label: "ウォークスルー",
      enter: "ウォークスルー",
      exit: "ウォークスルー終了",
      previous: "前の地点",
      next: "次の地点",
      moveToPoint: "{{ordinal}}番の地点へ移動",
      progress: "{{current}} / {{total}}",
      miniMap: "セッションミニマップ",
      departedPoint: "直前の地点",
      currentPoint: "現在の地点",
      departedDirection: "直前の地点の方向",
      relation: {
        previous: "直前の地点",
        next: "次の地点",
        spatial: "近接地点",
      },
      compass: {
        n: "北",
        ne: "北東",
        e: "東",
        se: "南東",
        s: "南",
        sw: "南西",
        w: "西",
        nw: "北西",
      },
      dualFisheye: "スティッチされていない原本のため360°で開けません",
    },
    card: {
      close: "閉じる",
      previewClose: "プレビューを閉じる",
      loadFailed: "読み込めませんでした",
      unplayableVideo: "このブラウザでは再生できない動画形式です。ダウンロードしてご確認ください。",
      download: "ダウンロード",
      deleteFile: "ファイル削除",
      deleteFileConfirm: "ファイルを削除しますか？",
      deleteScopePrompt: "削除対象",
      scopePrompt: {
        place: "位置修正対象",
        clear: "位置解除対象",
      },
      clearAllConfirm: "この位置の{{count}}枚の位置をすべて解除しますか？",
      scopeThis: "この写真のみ",
      scopeAll: "全{{count}}枚",
      positionSetting: "位置設定",
      editPosition: "位置修正",
      editPositionShort: "修正",
      editLocationName: "位置名を編集",
      clearPosition: "位置解除",
      clearPositionShort: "解除",
      clearPositionConfirm: "位置を解除しますか？",
      release: "解除",
      delete: "削除",
      cancel: "キャンセル",
      detail: "詳細表示",
      prevFile: "前のファイル",
      nextFile: "次のファイル",
      addHere: "この位置に写真を追加",
      addPhoto: "写真追加",
      addPhotoShort: "追加",
      addHereSelect: "この位置に追加するファイルを選択（{{count}}）",
    },
    marker: {
      placeHint:
        "地図をクリックして位置を指定 · 既存マーカーをクリックでその位置に追加",
      mapUploadHint:
        "地図上の好きな位置にファイル·フォルダをドラッグしてください",
      rightClickCancel: "右クリックでキャンセル",
      single: "{{name}} マーカー",
      cluster: "写真·動画 {{count}}件 マーカー",
      addToHere: "{{name}} をこの位置に追加",
    },
    notice: {
      onlyGeoLog: "画像·動画ファイルのみアップロードできます",
      emptyFile: "空のファイルはアップロードできません",
      excludedNonGeoLog: "画像·動画以外のファイル{{count}}件を除外しました",
      dropOnModel: "モデルの上にドロップしてください",
      placeFailed: "位置指定に失敗しました",
      uploadFailed: "アップロードに失敗しました",
      alreadyUploading:
        "すでにアップロード中のファイル{{count}}件をスキップしました",
      uploadTooLarge: "一度にアップロード可能な容量{{limit}}を超えています",
      quotaExceeded: "合計容量{{limit}}を超えるためアップロードできません",
      usageUnknown: "保存容量を確認できないためアップロードできません",
      partialExcluded:
        "{{count}}件のファイルを除いてアップロードします（{{detail}}）",
      allExcluded: "アップロードできるファイルがありません（{{detail}}）",
      excludeReason: {
        empty: "0バイト",
        nonMedia: "非対応形式",
        invalidName: "ファイル名エラー",
        tooLarge: "容量超過",
      },
      deleteFailed: "ファイル削除に失敗しました",
      listFailed: "一覧の読み込みに失敗しました",
      clearFailed: "位置解除に失敗しました",
      addFailed: "写真の追加に失敗しました",
      updateMetaFailed: "情報の修正に失敗しました",
      updateMetaSaved: "保存しました",
      downloadFailed: "ダウンロードに失敗しました",
      loadFailed: "一覧の読み込みに失敗しました",
      retry: "再試行",
    },
    scope: {
      drawArea: "領域フィルター",
      addArea: "領域を追加",
      hint: "地図に領域を描くかマーカーをクリックすると、その領域の写真・動画だけを表示できます。地図上の領域をもう一度クリックすると、選択した領域から除外されます。",
      help: "領域フィルターのヘルプ",
      areas: "領域 {{count}}個",
      areaLabel: "領域 {{n}}",
      count: "{{count}} / {{total}}",
      countAria: "全{{total}}件中 {{count}}件を表示",
      drawing: "領域を描いています…",
      drawCancel: "描画をキャンセル",
      drawingHint:
        "地図をドラッグして領域を描いてください。ESC または右クリックでキャンセルできます。",
      dragOnGround: "4つの角がすべて地面の上に来るように描いてください",
      flyTo: "領域へ画面を移動",
      clear: "フィルター解除",
      empty: "選択した領域に写真・動画がありません",
      emptyHint: "別の領域を描くか、すべての一覧に戻ってください",
      emptyNoPositioned:
        "位置が指定された写真・動画がありません。下の「位置なし」グループで位置を指定してください",
      showAll: "すべて表示",
      unpositionedTag: "範囲と無関係",
      unpositionedDesc:
        "位置を指定すると、範囲の内外に応じて一覧に表示されます",
      placedOutside: "領域の外に指定されたため一覧には表示されません",
      dropWhileDrawing: "領域の描画中はアップロードできません",
    },
    usage: {
      title: "使用容量",
    },
  },
  equipment: {
    menu: "機材・施設",
    title: "機材・施設",
    totalCount: "全{{count}}件",
    showOnMap: "地図に表示",
    listLabel: "機材・施設",
    add: "機材・施設を追加",
    addFolder: "フォルダー追加",
    captureView: "画面キャプチャ",
    captureFormat: "画像形式",
    loading: "機材・施設を読み込み中",
    loadFailedTitle: "機材・施設を読み込めませんでした",
    loadFailedDesc: "しばらくしてから再度お試しください。",
    refreshFailed: "機材・施設リストを更新できませんでした",
    dock: {
      label: "機材・施設",
      close: "機材・施設リストを閉じる",
      collapse: "折りたたむ",
      all: "すべて",
      categories: "機材・施設の分類",
      types: "機材・施設の種類",
      prev: "前の機材・施設",
      next: "次の機材・施設",
      loadFailed: "機材の種類を読み込めませんでした",
      refreshFailed: "機材の種類を更新できませんでした",
      empty: "追加できる機材・施設がありません",
    },
    catalog: {
      category: {
        lifting: "揚重・高所",
        earthwork: "土工・運搬",
        temporary: "仮設",
        material: "資材",
        labor: "人員",
      },
      type: {
        towerCrane: "タワークレーン",
        mobileCrane: "移動式クレーン",
        aerialPlatform: "高所作業車",
        excavator: "油圧ショベル",
        dumpTruck: "ダンプトラック",
        mixerTruck: "ミキサー車",
        loader: "ローダー",
        roller: "ローラー",
        concretePump: "ポンプ車",
        drillRig: "掘削機",
        forklift: "フォークリフト",
      },
    },
    intro: {
      title: "機材・施設を事前に動かしてみましょう",
      riskTag: "危険",
      speedTag: "{{speed}} km/h",
      realSizeTitle: "実寸",
      realSizeDesc: "実寸のモデルで配置します",
      reachTitle: "作業半径の確認",
      reachDesc: "重なる作業半径を事前に確認します",
      simulationTitle: "シミュレーション",
      simulationDesc: "好きな動線と速度で動かせます",
    },
    list: {
      risk: "危険 {{count}}",
      toggleVisibility: "{{name}}を地図に表示",
      expand: "{{name}}を展開",
      rowMenu: "{{name}}のその他",
      visibilityFailed:
        "地図の表示を切り替えられませんでした。しばらくしてからもう一度お試しください",
      moveTo: "この位置へ移動",
      rename: "名前を変更",
      delete: "削除",
      duplicate: "複製",
      duplicateSuffix: "（コピー）",
      duplicateFailed: "複製できませんでした。しばらくしてからもう一度お試しください",
      duplicateFolderFailed: "フォルダーを複製できませんでした。しばらくしてから再度お試しください",
      deleteFolderFailed: "フォルダーを削除できませんでした。しばらくしてから再度お試しください",
      captureFailed: "画面をキャプチャできませんでした。しばらくしてから再度お試しください",
      renameInput: "{{name}}の名前",
      renameConfirm: "{{name}}の名前を保存",
      renameCancel: "{{name}}の名前変更をキャンセル",
      renameFailed:
        "名前を変更できませんでした。しばらくしてからもう一度お試しください",
      deleteFailed:
        "機材・施設を削除できませんでした。しばらくしてからもう一度お試しください",
      deleteTitle: "機材・施設の削除",
      deleteMessage: "「{{name}}」を削除しますか？",
      deleteSubMessage: "削除した機材・施設は元に戻せません。",
      deleteCancel: "キャンセル",
      deleteConfirm: "削除",
    },
    detail: {
      tabs: "{{name}}の詳細",
      tab: {
        spec: "規格",
        position: "位置・向き",
        route: "動線",
      },
      cancel: "キャンセル",
      apply: "適用",
      position: "位置",
      moveOnMap: "地図で移動",
      longitude: "経度",
      latitude: "緯度",
      altitude: "高さ",
      heading: "向き",
      headingInput: "向き(度)",
      moving: "移動中",
      origin: "元の位置",
      specFailed:
        "規格を保存できませんでした。しばらくしてからもう一度お試しください",
      headingFailed:
        "向きを保存できませんでした。しばらくしてからもう一度お試しください",
      moveFailed:
        "位置を移動できませんでした。しばらくしてからもう一度お試しください",
    },
    route: {
      emptyTitle: "まだ動線がありません",
      emptyBody: "地図に点を打って動線を描きます。",
      draw: "動線を描く",
      drawing: "動線を描画中",
      editing: "動線を修正中",
      cancel: "キャンセル",
      done: "完了",
      distance: "距離",
      points: "地点",
      pointsLimit: "動線の地点は最大{{max}}個までです",
      duration: "予想時間",
      meters: "{{distance}} m",
      play: "動線を再生",
      pause: "一時停止",
      repeat: "リピート再生",
      repeatShort: "リピート",
      position: "再生位置",
      positionValue: "{{elapsed}} / {{total}}",
      speed: "速度",
      speedSlider: "再生速度",
      simulation: "動線シミュレーション",
      speedUnit: "km/h",
      edit: "修正",
      delete: "削除",
      locked: "動線の再生を止めると修正できます。",
      deleteTitle: "動線を削除",
      deleteMessage: "'{{name}}'の動線を削除しますか?",
      deleteSubMessage: "削除した動線は復元できません。",
      deleteCancel: "キャンセル",
      deleteConfirm: "削除",
      saveFailed:
        "動線を保存できませんでした。しばらくしてからもう一度お試しください",
      deleteFailed:
        "動線を削除できませんでした。しばらくしてからもう一度お試しください",
    },
    placement: {
      createFailed: "機材・施設を配置できませんでした。しばらくしてから再度お試しください",
      name: "名前",
      spec: "基準規格",
      custom: "直接入力",
      dimensions: "寸法",
      length: "全長",
      width: "全幅",
      height: "全高",
      reach: "作業半径",
      unit: "m",
      radiusColor: "半径の色",
      radiusColorDisabled: "作業半径があるときに選べます",
      close: "閉じる",
      place: "配置",
      error: {
        nameRequired: "名前を入力してください",
        nameTooLong: "名前は{{max}}文字まで入力できます",
        dimensionRange: "0より大きく{{max}}以下で入力してください",
        reachRange: "0〜{{max}}で入力するか、空のままにしてください",
      },
    },
    radiusColor: {
      peach: "ピーチ",
      lemon: "レモン",
      mint: "ミント",
      lavender: "ラベンダー",
      pink: "ピンク",
    },
  },
} as const;

export default timeSeries;
